import api from '../api'
import qs from 'qs'

export default {
  namespace: true,
  state: {
    asset_groups: [],
    asset_groups_user: [],
    error: null,
  },
  getters: {
    assetGroups(state) {
      return state.asset_groups;
    },
    assetGroupsUser(state) {
      return state.asset_groups_user;
    }
  },
  mutations: {
    CLEAR_ASSET_GROUPS(state) {
      state.asset_groups.splice(0)
    },
    ADD_ASSET_GROUPS(state, asset) {
      state.asset_groups.push(asset);
    },
    CLEAR_ASSET_GROUPS_USER(state) {
      state.asset_groups_user.splice(0)
    },
    ADD_ASSET_GROUPS_USER(state, asset) {
      state.asset_groups_user.push(asset);
    },
    ADD_ERROR(state, data) {
      state.error = data;
    },
  },
  actions: {
    LOAD_ASSET_GROUPS({commit, rootState}) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_asset_groups`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_ASSET_GROUPS", response.data.data);
          }
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    },
    LOAD_ASSET_GROUPS_USER({commit, rootState}) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_asset_groups_user`,
          qs.stringify({
            token: rootState.token,
            user_id: rootState.user.user.id,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_ASSET_GROUPS_USER", response.data.data);
          }
        })
        .catch((error) => {
          commit("ADD_ERROR", error);
        });
    }
  }
}
